"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _allowed = _interopRequireDefault(require("../utils/allowed"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Thead = function Thead(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement("thead", _extends({
    "data-testid": "thead"
  }, (0, _allowed["default"])(props)), /*#__PURE__*/_react["default"].cloneElement(children, {
    inHeader: true
  }));
};

Thead.propTypes = {
  children: _propTypes["default"].node
};
Thead.defaultProps = {
  children: undefined
};
var _default = Thead;
exports["default"] = _default;